import { DataProxy } from 'apollo-cache'
import { removeFromPaginated } from 'utils'

export interface HandleShareDeletedPermanentlyProps {
  cache: DataProxy
  shareIdentifier: string
}

export const handleShareDeletedPermanently = (
  props: HandleShareDeletedPermanentlyProps
) => {
  const { cache, shareIdentifier } = props

  removeFromPaginated(
    cache,
    { __typename: 'Share', identifier: shareIdentifier },
    key => key.includes('workspaceTrash')
  )
}
